module.exports = __webpack_public_path__ + "img/motorcycles.d9a3d26f.jpg";